import React from "react";
import { User, Crown } from "lucide-react";

/**
 * Reusable identity avatar shared by Sidebar, AppShell settings, Profile, and FeedItem.
 * Overlays a small gold Founder mark (same gradient/font family as the Seals) whenever
 * isRootAdmin is true — the 'Sovereign Founder' Zero-Gap consistency requirement.
 */
const ProfileAvatar = ({ name, color, sizeClass = "w-10 h-10", textClass = "text-sm", isRootAdmin = false, className = "" }) => {
  return (
    <div className={`relative inline-flex shrink-0 ${className}`} data-testid="profile-avatar">
      <div
        className={`${sizeClass} rounded-full flex items-center justify-center text-white font-serif shrink-0 ${textClass} ${!color ? "bg-gradient-to-br from-secondary to-primary" : ""}`}
        style={color ? { background: color } : undefined}
      >
        {name?.[0]?.toUpperCase() || <User className="w-1/2 h-1/2" />}
      </div>
      {isRootAdmin && (
        <span
          data-testid="founder-avatar-mark"
          title="Sovereign Founder"
          className="absolute -bottom-1 -right-1 w-[46%] h-[46%] min-w-[15px] min-h-[15px] rounded-full flex items-center justify-center border-2"
          style={{ background: "linear-gradient(135deg, #f6e3a3 0%, #c9a24a 50%, #8a6a2a 100%)", borderColor: "var(--background, #fff)" }}
        >
          <Crown className="w-[62%] h-[62%]" style={{ color: "#3d2e0f" }} />
        </span>
      )}
    </div>
  );
};

export default ProfileAvatar;
